/*
    content:法规宣导管理系统接口列表
    time:2020-10-12

*/


import http from '../http'

//在线广播
const broadcastMngApi = {
    queryBroadcastDeviceState: p => http.get('/publicize/contentSet/broadcastDeviceState', p), //音频-广播设备状态
    queryResourceList: p => http.get('/publicize/contentSet/resourcePage', p), //音频-列表
    deleteResource: p => http.delete('/publicize/contentSet/delResource', p), //音频-删除
    insertResource: p => http.postJson('/publicize/contentSet/addResource', p), //音频-新增
    playAudioFiles: p => http.get('/publicize/contentSet/playAudioFiles', p), //播放文件广播
    queryCurPlayStatus: p => http.get('/publicize/contentSet/curPlayStatus', p), //当前广播播放状态
    stopAudioBroadcast: p => http.get('/publicize/contentSet/stopAudioBroadcast', p), //停止播放广播
}

//看板内容
const kanbanMngApi = {
    // 内容列表   
    queryContentSetList: p => http.get('/publicize/contentSet/search', p),
    updatePublicizeRes: p => http.put('/publicize/contentSet/updatePublicizeRes', p),
    getPublicizeDeviceList2: p => http.get('/publicize/contentSet/getPublicizeDeviceList', p),
    getPublicizeDeviceList: p => http.get('/device/device/getLedDevice', p),
    publicizeShowPage: p => http.get('/publicize/contentSet/publicizeShowPage', p),
    querySettingDetails: p => http.get(`/publicize/contentSet/${p}`),
    addPublicizeRes: p => http.postJson(`/publicize/contentSet/addPublicizeRes`,p),  //新增和编辑
    addAndSavePublicize: p => http.postJson(`/publicize/contentSet/addAndSavePublicize`,p),  //新增并修改投放计划
    savePublicizePlan: p => http.postJson(`/publicize/contentSet/savePublicizePlan`,p),  //修改投放计划
    deletePublicize: p => http.delete(`/publicize/contentSet/delResource`,p),  //删除投放资源

    removePublicizePlan: p => http.deleteJson(`/publicize/contentSet/removePublicizePlan`,p),  //删除投放资源
    
}


export default Object.assign({}, broadcastMngApi, kanbanMngApi)